var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.0043 10.3459H20.9958C15.1234 10.3459 10.3459 15.1234 10.3459 20.994V70.0043C10.3459 75.8766 15.1234 80.6523 20.9958 80.6523H70.0043C75.8766 80.6523 80.6541 75.8748 80.6541 70.0043V20.9958C80.6541 15.1234 75.8766 10.3459 70.0043 10.3459ZM74.9666 70.0043C74.9666 72.7396 72.7414 74.9648 70.0043 74.9648H20.9958C18.2605 74.9648 16.0334 72.7396 16.0334 70.0043V20.9958C16.0334 18.2605 18.2587 16.0352 20.9958 16.0352H70.0043C72.7396 16.0352 74.9666 18.2605 74.9666 20.9958V70.0043Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9251 42.6563H48.3438V28.075C48.3438 26.5038 47.0712 25.2312 45.5 25.2312C43.9289 25.2312 42.6563 26.5038 42.6563 28.075V42.6563H28.075C26.5038 42.6563 25.2312 43.9289 25.2312 45.5C25.2312 47.0712 26.5038 48.3438 28.075 48.3438H42.6563V62.9251C42.6563 64.4963 43.9289 65.7689 45.5 65.7689C47.0712 65.7689 48.3438 64.4963 48.3438 62.9251V48.3438H62.9251C64.4963 48.3438 65.7689 47.0712 65.7689 45.5C65.7689 43.9289 64.4963 42.6563 62.9251 42.6563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSearch);
export default __webpack_public_path__ + "static/media/new_search.a65ea19391773f47b532b1b9ff83d409.svg";
export { ForwardRef as ReactComponent };